import Slider from '@vueform/slider'
import iCon from '@/components/ui/svgicon/index';
export default {
    name: 'ui-demo',
    components: {
        Slider,
        iCon,
    },
    props: {
        title: { // placeholder
            type: String,
            default: '',
            require: false,
        },
        unit: { // placeholder
            type: String,
            default: " cd/m²"
        },
        data: { // placeholder
            type: Array,
            default: [
                100, 200, 300, 400, 500, 600, 700, 800, 900
            ]
        },
        right_fix: {
            type: Number,
            default: 5
        },
        difference: {
            type: Number,
            default: 1,
        },
        size: { // placeholder
            type: String,
            default: ""
        },
        max: {
            type: Boolean,
            default: false
        },
        min: {
            type: Boolean,
            default: false
        },
        dot: {
            type: Boolean,
            default: false
        },
        max_value: {
            type: Number,
            default: 1000000,
        },
        min_value: {
            type: Number,
            default: 0,
        },
        disable: {
            type: Boolean,
            default: false
        },
        lock: {
            type: Boolean,
            default: false
        },
        startValue: {
            type: Number,
            default: 500,
        },
        isTemperature: {
            type: Boolean,
            default: false
        },
        disableInput: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            value: 0,
            _value: this.data[0],
            _step: 0,
            _max: false,
            _min: false,
        }
    },
    methods: {
        pasteInput(event){
            event.preventDefault();
        },
        intOnly(event) {
            event = (event) ? event : window.event;
            var charCode = (event.which) ? event.which : event.keyCode; // 
            if (charCode == 189 || charCode == 190 || charCode == 110 || charCode == 109 || charCode == 107 || charCode == 187){
                event.preventDefault();
            }
        },
        onclick(val) {
            this.value = this._step * val
        },
        onchange(val) {
            // console.log('??',val.target.value, this._value)
            this._value = val.target.value
            var v = val.target.value
            if (this.isTemperature) {
                v = Math.round(v / 100);
            }
            if (this.dot) {
                if (v <= this.data[0]) {
                    if (this.min) {
                        if (v == this.data[0]) {
                            this.value = this._step
                        } else {
                            this.value = 0
                        }
                    } else {
                        this.value = 0
                    }
                } else if (v >= this.data[this.data.length - 1]) {
                    if (this.max) {
                        if (v == this.data[this.data.length - 1]) {
                            this.value = this.step - this._step;
                        } else {
                            this.value = this.step;
                        }
                    } else {
                        this.value = this._step * this.data.length - 1;
                    }
                } else {
                    for (a = 1; a < this.data.length; a++) {
                        if (v < this.data[a] && v >= this.data[a - 1]) {
                            fix = this.min ? this._step : 0;
                            if (v < this.data[a] - (this.data[a] - this.data[a - 1]) / 2) {
                                this.value = a - 1 + fix;
                            } else {
                                this.value = a + fix;
                            }
                        }
                    }
                }
                fix = this.min ? this._step : 0;
                this._value = 0
                this._value = this.data[this.value - fix]
            } else {
                if (v <= this.data[0]) {
                    if (this.min) {
                        if (v == this.data[0]) {
                            this.value = this._step
                        } else {
                            this.value = 0
                        }
                    } else {
                        this.value = 0
                        if (this.isTemperature) { 
                            this._value = this.data[0] * 100
                        }else{
                            this._value = this.data[0] 
                        }
                    }
                } else if (v >= this.data[this.data.length - 1]) {
                    // console.log('不是點 2',v , this.max ,this.data[this.data.length - 1] ,this.data, this.max_value)
                    if (this.isTemperature) {
                        this._value = Math.round(val.target.value / 100) * 100;
                    }
                    if (this.max) {
                        if (v == this.data[this.data.length - 1]) {
                            this.value = this.step - this._step;
                        } else {
                            this.value = this.step;
                        }
                    } else {
                        this.value = this.step 
                        if (this.isTemperature) {
                            this._value =   this.data[this.data.length - 1] * 100 
                        }else{
                            this._value = this.data[this.data.length - 1] 
                        }
                        
                    }
                } else {
                    for (var a = 1; a < this.data.length; a++) {
                        if (v < this.data[a] && v >= this.data[a - 1]) {
                            var fix = this.min ? this._step : 0;
                            this.value = Math.round(((this._step * (a - 1)) + this._step / (this.data[a] - this.data[a - 1]) * (v - this.data[a - 1])) + fix);
                        }
                    }
                }
            }

        },
        value_add(v, flag) {
            if (this.dot) {
                if (v > 0) {
                    v = 1
                } else if (v < 0) {
                    v = -1
                }
                this.value += v;
            } else {
                this.value += v;
                if (this.max) {
                    // console.log('value_add', this.value , this.step - this._step / 2)
                    if(flag){  //(this.value > this.step - this._step / 2) 判斷是否在最大值與MAX中的一半以上
                        this.value = this.step;
                    }else{
                        this.value = this.step - this._step;
                    }
                    if (this.value <= this.step - this._step / 2 && this.value > this.step - this._step) {
                        this.value = this.step;
                    }
                }
                //這段不知道要幹嘛餒QQ 是不是沒用到
                var _check = this._value;
                setTimeout(() => {
                    if (_check == this._value) {
                        this.value += v;
                    }
                }, 1);
                //這段不知道要幹嘛餒QQ 是不是沒用到
            }
        },
        slider_change() {
            if (this.min) {
                if (this.value < this._step / 2) {
                    this.value = 0;
                }
                if (this.value >= this._step / 2 && this.value < this._step) {
                    this.value = this._step;
                }
            }
            if (this.max) {
                if (this.value > this.step - this._step / 2) {
                    // console.log(this.value , this.step - this._step /2, this.step , this._step)
                    this.value = this.step;
                }
                if (this.value <= this.step - this._step / 2 && this.value > this.step - this._step) {
                    // console.log(this.value , this.step - this._step / 2 ,  this.step - this._step)
                    this.value = this.step - this._step;
                }
            }
        }
    },
    mounted() {
        this.$emit('onChange', this._value);
        this._value = this.isTemperature ? this.data[0] * 100 : this.data[0];
    },
    computed: {
        _data() {
            var __data = [];
            if (this.min) {
                var _val_min = {
                    value: 0,
                    left: -5,
                    index: 0,
                    text: "Min",
                }
                __data.push(_val_min);
                // this.value = this._step;
                // setTimeout(() => { this.value = this._step }, 1);
            }
            for (var a = 0; a < this.data.length; a++) {
                var _val = {
                    value: 0,
                    left: 0,
                    index: 0,
                    text: 0,
                }
                _val.value = this._step * (a + (this.min ? 1 : 0));
                _val.text = this.data[a]
                if (_val.text == 2) {
                    _val.text = "2.0";
                }
                if (this.size == "small") {
                    _val.left = (452 / (this.data.length - 1 + (this.max ? 1 : 0) + (this.min ? 1 : 0)) * (a + (this.min ? 1 : 0))) - 5;
                } else {
                    _val.left = (672 / (this.data.length - 1 + (this.max ? 1 : 0) + (this.min ? 1 : 0)) * (a + (this.min ? 1 : 0))) - 5;
                }
                _val.index = (a + (this.min ? 1 : 0));
                __data.push(_val);
            }
            if (this.max) {
                var _val_max = {
                    value: 0,
                    left: -5,
                    index: __data.length,
                    text: "Max",
                }
                _val_max.value = this._step * __data.length;
                if (this.size == "small") {
                    _val_max.left = 452 - 5;
                } else {
                    _val_max.left = 672 - 5;
                }
                __data.push(_val_max);
            }
            if (this.startValue > this.data[this.data.length - 1] && this.max) {
                this._max = true;
                this._min = false;
            } else if (this.startValue < this.data[0] && this.min) {
                this._max = false;
                this._min = true;
            } else {
                this._max = false;
                this._min = false;
            }
            setTimeout(() => {
                if (this.min == false && this.startValue < this.data[0]) {
                    if (this.isTemperature) {
                        this.onchange({ target: { value: this.data[0] * 100 } })
                    } else {
                        this.onchange({ target: { value: this.data[0] } })
                    }
                } else {
                    if (this.isTemperature) {
                        this.onchange({ target: { value: this.startValue * 100 } })
                    } else {
                        this.onchange({ target: { value: this.startValue } })
                    }
                }
            }, 1);
            return __data
        },
        step() {
            var _s = 0;
            if (this.dot) {
                // console.log("dot")
                _s = 1;
                this._step = _s;
                _s = _s * (this.data.length - 1 + (this.max ? 1 : 0) + (this.min ? 1 : 0));
            } else {
                for (var a = 1; a < this.data.length; a++) {
                    if (this.data[a] - this.data[a - 1] > _s) {
                        _s = this.data[a] - this.data[a - 1];
                    }
                }
                this._step = _s;
                _s = _s * (this.data.length - 1 + (this.max ? 1 : 0) + (this.min ? 1 : 0));
                // _s = _s*(this.data.length-1);
            }
            // console.log(_s)
            return _s;
        },
    },
    watch: {
        value: function () {
            // this._value =this.data[0]+this.value;
            if (this.dot) {
                // console.log("dot")
                if (this.min || this.max) {
                    if (this.min && this.max) {
                        if (this.value == 0) {
                            this._min = true;
                            this._value = this.min_value
                        } else if (this.value == this.data.length + 1) {
                            this._max = true
                            this._value = this.max_value;
                        } else {
                            this._min = false;
                            this._max = false;
                            this._value = this.data[this.value - 1];
                        }
                    } else if (this.max) {
                        if (this.value == this.data.length) {
                            this._max = true
                            this._value = this.max_value;
                        } else {
                            this._min = false;
                            this._max = false;
                            this._value = this.data[this.value];
                        }
                    } else if (this.min) {
                        if (this.value == 0) {
                            this._min = true;
                            this._value = this.min_value
                        } else {
                            this._min = false;
                            this._max = false;
                            this._value = this.data[this.value - 1];
                        }
                    }
                } else {
                    this._value = this.data[this.value];
                }
            } else {
                if (this.max || this.min) {
                    if (this.max && this.min) {
                        if (this.value < this._step) {
                            if (this.value < this._step / 2) {
                                this._min = true;
                                this._value = this.min_value
                            } else {
                                this._min = false;
                                this._value = this.data[0]
                            }
                        } else if (this.value > this.step - this._step) {
                            if (this.value > (this.step - this._step / 2)) {
                                this._max = true;
                                this._value = this.max_value
                            } else {
                                this._max = false;
                                this._value = this.data[this.data.length - 1]
                            }
                        } else if (this.value == this.step - this._step) {
                            this._max = false;
                            this._value = this.data[this.data.length - 1]
                        } else {
                            this._min = false;
                            this._max = false;
                            for (var a = 0; a < this.data.length - 1; a++) {
                                if (parseInt(this.value / this._step) == a + 1) {
                                    this._value = Math.ceil(this.data[a] + ((this.data[a + 1] - this.data[a]) / this._step * (this.value - this._step * (a + 1))));
                                }
                            }
                        }
                    } else if (this.max) {
                        if (this.value > this.step - this._step) {
                            if (this.value > (this.step - this._step / 2)) {
                                // issue 271 有要顯示最大值的時候，最大值的位置會有問題
                                this._max = true;
                                this._value = this.max_value
                            } else {
                                this._max = false;
                                this._value = this.data[this.data.length - 1]
                            }
                        } else if (this.value == this.step - this._step) {
                            this._max = false;
                            this._value = this.data[this.data.length - 1]
                        } else {
                            this._min = false;
                            this._max = false;
                            for (a = 0; a < this.data.length - 1; a++) {
                                if (parseInt(this.value / this._step) == a) {
                                    this._value = Math.ceil(this.data[a] + ((this.data[a + 1] - this.data[a]) / this._step * (this.value - this._step * a)));
                                }
                            }
                        }
                    } else if (this.min) {
                        if (this.value < this._step) {
                            if (this.value < this._step / 2) {
                                this._min = true;
                                this._value = this.min_value
                            } else {
                                this._min = false;
                                this._value = this.data[0]
                            }
                        } else {
                            this._min = false;
                            this._max = false;
                            for (a = 0; a < this.data.length - 1; a++) {
                                if (parseInt(this.value / this._step) == a + 1) {
                                    this._value = Math.ceil(this.data[a] + ((this.data[a + 1] - this.data[a]) / this._step * (this.value - this._step * (a + 1))));
                                }
                            }
                            if (this.value == this.step) {
                                this._value = this.data[this.data.length - 1];
                            }
                        }
                    }
                } else {
                    for (a = 0; a < this.data.length - 1; a++) {
                        if (parseInt(this.value / this._step) == a) {
                            this._value = Math.round(this.data[a] + ((this.data[a + 1] - this.data[a]) / this._step * (this.value - this._step * a)));
                        }
                    }
                    if (this.value == this.step) {
                        this._value = this.data[this.data.length - 1];
                    }
                }
            }
            if (this.isTemperature) {
                if( this._value != this.data[this.data.length - 1]*100){
                    this._value *= 100;
                }
            }
        },
        _value: function () {
            if (this._min) {
                this.$emit('onChange', this.min_value);
            } else {
                this.$emit('onChange', this._value);
            }
        }
    },
}